













































































































































































































































































import PanelGroup from "./components/PanelGroup.vue";
import LineChart from "./components/LineChart.vue";
import BoxCard from "./components/BoxCard.vue";
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { overviewRequest, OverviewReq, History } from "@/api/admin";
import {
  ResCode,
  Meter,
  MeterType,
  Company,
  User,
  MeterCost,
  Address,
  MeterAlarm,
} from "@/api/baseDefine";
import {
  formatDate,
  formatDateTime,
  formatHour,
  formatMonth,
  formatYear,
} from "@/utils/dateUtil";
import { MeterUtil } from "@/utils/meterUtil";
import { queryUser, QueryUserReq } from "@/api/user";
import { geCompanys, CompanyCommonReq } from "@/api/company";
import { getAddresses, GetAddress } from "@/api/address";
import { QueryMeterCostReq, queryMeterCost } from "@/api/meterCost";
import {
  QueryMeterReq,
  queryMeter,
  meters,
  GetMetersReq,
  MeterTypes,
  meterTypes,
} from "@/api/meter";
const lineChartData = {
  xDatas: ["0"],
  usages: [0],
  readings: [0],
};

@Component({
  components: {
    PanelGroup,
    LineChart,
  },
})
export default class DashboardAdmin extends Vue {
  private meterTypeUnits: string[] = ["m³", "kWh", "m³", "MWh", "kWh"];
  private unit: string = "";
  public lineChartData = lineChartData;
  private selectDate = formatDate(new Date());
  private meterTypes: string[] = [];
  private timeArray: string[] = [];
  private list: MeterAlarm[] = [];
  private listLoading = false;
  public stateInfos: string[] = [];
  public stateCounts = [0, 0];
  private selectMeterTypeID = 0;
  public countData = [0, 0, 0, 0, 0];
  private time = "";
  private meterType = this.meterTypes[0];
  private overviewReq: OverviewReq = <OverviewReq>{ historyMeterTypeID: 1 };
  private curMeterTypes: MeterType[] = [];

  private queryCompanys: Company[] = [];
  private queryUsers: User[] = [];
  private queryInstallUsers: User[] = [];
  private queryMeters: Meter[] = [];
  private queryMeterCosts: MeterCost[] = [];
  private addressSearchType = 1;
  private queryAddresses: Address[] = [];
  private searchMeter: Meter = <Meter>{};
  private loading: boolean = false;
  private selectIndex: number = 0;
  // 设备分析
  public async analyzeMeters() {
    this.overview();
  }

  public changeTime() {
    this.chartPage = 0;
    this.overview();
  }
  public clickReset() {
    this.searchMeter = <Meter>{};
    this.overview();
  }
  public handleClickPanelGroup(index) {
    this.selectIndex = index;
    this.selectMeterTypeID = this.curMeterTypes[index].id;
    this.chartPage = 0;
    this.overview();
  }
  public changeAddress() {
    this.chartPage = 0;
    this.overview();
  }
  public changeCity() {
    this.chartPage = 0;
    this.overview();
  }
  public changeMeterID() {
    this.chartPage = 0;
    this.overview();
  }
  public changeCompany() {
    this.chartPage = 0;
    this.overview();
  }
  public changeProvince() {
    this.chartPage = 0;
    this.overview();
  }
  public onSelectOwnUser(b) {
    if (b) {
      this.queryOwnUser("");
    }
  }

  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }

  public onSelectParentMeterID(b) {
    if (b) {
      this.queryMeter("");
    }
  }
  public onSelectChangeDetail(b) {
    if (b) {
      this.addressSearchType = 4;
      this.queryAddress("");
    }
  }
  public onSelectChangeProvince(b) {
    if (b) {
      this.addressSearchType = 2;
      this.queryAddress("");
    }
  }

  public onSelectChangeCity(b) {
    if (b) {
      this.addressSearchType = 3;
      this.queryAddress("");
    }
  }
  public async queryMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meters(<GetMetersReq>{ meter: { meterID: query } });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }
  public async queryMeterCost(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryMeterCost(<QueryMeterCostReq>{ query: query });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeterCosts = res.data.meterCostData.list;
        this.loading = false;
      }
    }
  }
  public async queryOwnUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 0,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public async queryAddress(query: string) {
    let req: GetAddress = <GetAddress>{};
    let address: Address = <Address>{};
    req.page = 1;
    req.pageSize = 10;
    req.address = address;
    this.loading = true;
    const res = await getAddresses(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryAddresses = res.data.addressesData.list;
      this.loading = false;
    }
  }

  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }
  public async queryInstallUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 1,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryInstallUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  private firstMeterTypes: MeterType[] = [];
  private first: boolean = false;
  private chartPage: number = 0;

  public async next() {
    if (
      !!this.selectDate &&
      Date.now() - new Date(this.selectDate).getTime() < 1 * 60 * 60 * 1000
    ) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.alreadyLastPage").toString(),
        type: "warning",
      });
      return;
    }
    this.chartPage++;
    this.overview();
  }

  public async pre() {
    this.chartPage--;
    this.overview();
  }

  public selectDateChange() {
    this.overview(true);
  }

  private async overview(selectDateFlag?: boolean) {
    let timeID = this.timeArray.indexOf(this.time);
    timeID++;

    let date: Date = new Date();
    if (!!this.selectDate) {
      date = new Date(this.selectDate);
    }
    if (!selectDateFlag) {
      if (timeID === 1) {
        date = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + this.chartPage,
          date.getHours()
        );
      } else if (timeID === 2) {
        date = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + this.chartPage * 7,
          date.getHours()
        );
      } else if (timeID === 3) {
        date = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + this.chartPage * 28,
          date.getHours()
        );
      } else if (timeID === 4) {
        date = new Date(
          date.getFullYear(),
          date.getMonth() + this.chartPage * 1,
          date.getDate(),
          date.getHours()
        );
      } else if (timeID === 5) {
        date = new Date(
          date.getFullYear() + this.chartPage * 5,
          date.getMonth(),
          date.getDate(),
          date.getHours()
        );
      }
    } else {
      date = new Date(this.selectDate);
      date.setHours(new Date().getHours());
    }
    if (date.getTime() > Date.now()) {
      date = new Date();
    }
    this.overviewReq.timeID = timeID;
    this.overviewReq.historyMeterTypeID = this.selectMeterTypeID;
    this.overviewReq.date = formatDateTime(date);
    this.overviewReq.yesterday = formatDateTime(
      new Date(Date.now() - 24 * 60 * 60 * 1000)
    );
    this.overviewReq.meter = this.searchMeter;
    this.overviewReq.nowDate = formatDate(new Date());
    const res = await overviewRequest(this.overviewReq);
    if (res.code === ResCode.SUCCESS) {
      this.chartPage = 0;
      this.selectDate = this.overviewReq.date;
      this.showLine(res.data.historys, timeID);
      this.countData = res.data.meterCount;
      this.stateCounts = [0, 0];
      if (!!this.countData) {
        this.stateCounts[0] = this.countData[this.selectIndex];
      }
      this.list = res.data.meterAlarms;
      if (!!this.list) {
        this.stateCounts[1] = this.list.length;
        this.stateCounts[1] = res.data.alarmCount;
        for (let alarm of this.list) {
          let fault = alarm.fault;
          let res = "";
          if (alarm.type == 1) {
            for (let i = 0; i < fault.length; i++) {
              if (fault[i] === "1") {
                if (!res) {
                  res = this.meterFaults[alarm.meterTypeID - 1][8 - i];
                } else {
                  res =
                    res + "," + this.meterFaults[alarm.meterTypeID - 1][8 - i];
                }
              }
            }
            alarm.fault = res;
          } else if (alarm.type == 0) {
            alarm.fault = this.$t("meterState.leakage").toString();
          }
        }
        this.list.sort(function (a: MeterAlarm, b: MeterAlarm) {
          if (a.reportTime > b.reportTime) {
            return -1;
          } else {
            return 1;
          }
        });
      }

      // this.list = res.data.users.list;
      // this.total = res.data.users.totalCount;
    }
    this.curMeterTypes = MeterUtil.getMeterTypeByMeterCounts(
      this.countData,
      this.meterTypes,
      this.firstMeterTypes
    );
    if (!this.first) {
      this.first = true;
      this.firstMeterTypes = this.curMeterTypes;
      if (this.curMeterTypes.length >= 1) {
        this.selectMeterTypeID = this.curMeterTypes[0].id;
      }
      this.overview();
    }
  }

  private showLine(lists: History[], timeID: number) {
    this.lineChartData.xDatas = [];
    this.lineChartData.usages = [];
    this.lineChartData.readings = [];
    this.unit = this.meterTypeUnits[this.selectMeterTypeID - 1];
    for (let history of lists) {
      this.lineChartData.usages.push(history.usage);
      this.lineChartData.readings.push(history.reading);
      let time = history.time;
      let times = time.split(" ");
      if (timeID == 1) {
        time = formatHour(new Date(time));
      } else if (timeID == 2) {
        time = times[0];
      } else if (timeID == 3) {
        time = times[0];
      } else if (timeID == 4) {
        time = formatMonth(new Date(time));
      } else {
        time = formatYear(new Date(time));
      }
      this.lineChartData.xDatas.push(time);
    }
  }
  private meterFaults;
  private created() {
    this.meterFaults = [
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s11").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s14").toString(),
        this.$t("meterState.s15").toString(),
        this.$t("meterState.s16").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s18").toString(),
      ],
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s21").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s24").toString(),
        this.$t("meterState.s25").toString(),
        this.$t("meterState.s26").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s28").toString(),
      ],
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s11").toString(),
        this.$t("meterState.s32").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s14").toString(),
        this.$t("meterState.s35").toString(),
        this.$t("meterState.s36").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s18").toString(),
      ],
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s11").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s14").toString(),
        this.$t("meterState.s15").toString(),
        this.$t("meterState.s16").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s48").toString(),
      ],
      [
        this.$t("meterState.s50").toString(),
        this.$t("meterState.s51").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s54").toString(),
        this.$t("meterState.s25").toString(),
        this.$t("meterState.s26").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s58").toString(),
      ],
    ];
    this.meterTypes = [
      this.$t("meterTypes.water").toString(),
      this.$t("meterTypes.power").toString(),
      this.$t("meterTypes.gas").toString(),
      this.$t("meterTypes.hot").toString(),
      this.$t("meterTypes.pv").toString(),
    ];

    this.timeArray = [
      this.$t("timeArray.hours").toString(),
      this.$t("timeArray.days").toString(),
      this.$t("timeArray.weeks").toString(),
      this.$t("timeArray.months").toString(),
      this.$t("timeArray.years").toString(),
    ];
    this.time = this.timeArray[0];

    this.stateInfos = [
      this.$t("stateInfos.totalCount").toString(),
      this.$t("stateInfos.malfunctionCount").toString(),
    ];
    this.overview();
  }
}
